<template>
  <div class="wallet-stat">
    <custom-breadcrumb />
    <div class="stat-area-main">
      <div class="content">
        <span class="stat-title">Available Balance</span>
        <span class="stat-content" v-format="'$#,##0.00'">{{availableBalance}}</span>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="content">
        <span class="stat-title">Total Revenue</span>
        <span class="stat-content"  v-format="'$#,##0.00'">{{totalRevenue}}</span>
      </div>
      <el-divider direction="vertical"></el-divider>

      <div class="content">
        <span class="stat-title">Received</span>
        <span class="stat-content" v-format="'$#,##0.00'">{{received}}</span>
      </div>
      <el-divider direction="vertical"></el-divider>

      <div class="content">
        <span class="stat-title">Pending</span>
        <span class="stat-content" v-format="'$#,##0.00'">{{pending}}</span>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="content">
        <span class="stat-title">Earned</span>
        <span class="stat-content" v-format="'$#,##0.00'">{{withdrawn}}</span>
      </div>

  </div>
 </div>
</template>

<script>
import {getAction} from "@/api/manage.js";
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  components: {CustomBreadcrumb},
  data() {
    return {
      availableBalance: 0,
      totalRevenue: 0,
      received: 0,
      pending: 0,
      withdrawn: 0,
    }
  },
  created(){
      this.loadStat();
  },
  methods:{
      loadStat(){
        getAction("/sp/suppliers/wallet/count").then((res)=>{
          if (res.success) {
            if (res.result) {
              this.availableBalance = res.result.availableBalance;
              this.totalRevenue = res.result.totalRevenue;
              this.received = res.result.received;
              this.pending = res.result.pending;
              this.withdrawn = res.result.withdraw;

            }
          } else {
            this.$message.warning(res.message)
          }
        });

      }
  }
}
</script>

<style lang="less" scoped>
.wallet-stat {
  .payment{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 800;
    color: #262B2F;
  }

  .stat-area-main {
    height: 94px;
    border: 1px solid #E1E1E1;
    opacity: 1;
    line-height: 94px;
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    align-items: center;
    justify-content:space-around;
    font-family: Graphik;

    .content{
      height: 90px;
      width: 120px;
      text-align: center;
     .stat-title {
        padding-top: 20px;
        display: block;
        font-size: 13px;
        font-weight: 400;
        line-height: 12px;
      }
     .stat-content{
       display: block;
       font-size: 18px;
       font-weight: 800;
       color: #262B2F;
       line-height: 40px;
       margin-top: 15px;
     }



    }


  }
  /deep/ .el-divider--vertical{
    height: 80px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/wallet/stat-info.vue